import type { ChangeEvent } from "react"
import React, { useRef, useState } from "react"

import type { InputProps } from "@chakra-ui/react"
import {
  CloseButton,
  Input,
  InputGroup,
  InputRightElement,
} from "@chakra-ui/react"

import { clearDomInput } from "@supliful/common"

type DateInputProps = Omit<InputProps, "value"> & {
  value?: string
  isClearable?: boolean
}

export const DateInput = ({
  isClearable = true,
  value: controlledValue,
  onChange,
  ...rest
}: DateInputProps) => {
  const [value, setValue] = useState<string | undefined>(undefined)
  const inputRef = useRef(null)
  const controlled = controlledValue !== undefined
  const closeButtonDisabled = controlled ? !controlledValue : !value

  const onClear = () => {
    if (!controlled) {
      setValue(undefined)
    }
    clearDomInput(inputRef.current)
  }

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (!controlled) {
      setValue(event.target.value)
    }

    if (onChange) {
      onChange(event)
    }
  }

  return (
    <InputGroup>
      <Input
        ref={inputRef}
        type="date"
        fontSize={14}
        {...(isClearable && {
          pr: 8,
          minW: "11.5rem",
        })}
        {...(controlled && {
          value: controlledValue,
        })}
        onChange={handleChange}
        {...rest}
      />

      {isClearable && (
        <InputRightElement w={8}>
          <CloseButton
            title="Clear input"
            size="sm"
            onClick={onClear}
            isDisabled={closeButtonDisabled}
            display={closeButtonDisabled ? "none" : "flex"}
          />
        </InputRightElement>
      )}
    </InputGroup>
  )
}
